import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/tower.frag";
import MAD from "../mad-engine";

export default class Bridge extends MAD.Entity{
    constructor(){
        super();
        const uniforms = {
            u_curve: { type: "float", value: 0 },
            u_progress: { type: "float", value: 0 },
            u_color: { type: "color", value: new THREE.Color(`hsl(360,100%,65%)`) }
        };
        this.material =  new THREE.ShaderMaterial( {
            vertexShader,
            fragmentShader,
            uniforms
        });
        const geometry = new THREE.BoxGeometry();
        const cube = new THREE.Mesh( geometry, this.material );
        cube.scale.set(1000, 10, 10);
        this.root.add( cube );

        const { noise } = MAD.STORE.data;
        this.root.position.z = Math.random() * -250;
        this.root.position.y = noise.read(this.root.position.z) + 10 + 30 * Math.random();
    }

    update(){
        const { clock } = MAD.App.instance;
        const { noise } = MAD.STORE.data;

        this.root.position.z += noise.getSpeed();
        if(this.root.position.z > 10){
            this.root.position.z = -250 - Math.random() * 250;
            this.root.position.y = noise.read(this.root.position.z) + 10 + 30 * Math.random();
        }
        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.needsUpdate = true;
    }
}